// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LabelledCheckbox_wrapper__9gpKu","checkmark":"LabelledCheckbox_checkmark__1pMA-","dark":"LabelledCheckbox_dark__2AAPt"};